import { network } from 'services/network';

export const getGantActivitiesGraph = (params) => {
    return network.post('api/bo/getGantActivitiesGraph', params).then((response) => {
        return response.data;
    });
};
